const SvgComponent = ({ ...props }) => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.8139 6.94387C13.8139 8.46767 13.3192 9.87528 12.486 11.0173L16.6889 15.2235C17.1038 15.6385 17.1038 16.3124 16.6889 16.7274C16.2739 17.1424 15.6 17.1424 15.185 16.7274L10.9821 12.5212C9.84006 13.3578 8.43246 13.8491 6.90866 13.8491C3.09418 13.8491 0.00341797 10.7584 0.00341797 6.94387C0.00341797 3.12939 3.09418 0.0386353 6.90866 0.0386353C10.7231 0.0386353 13.8139 3.12939 13.8139 6.94387ZM6.90866 11.7244C9.54792 11.7244 11.6892 9.58313 11.6892 6.94387C11.6892 4.30461 9.54792 2.16332 6.90866 2.16332C4.26939 2.16332 2.12811 4.30461 2.12811 6.94387C2.12811 9.58313 4.26939 11.7244 6.90866 11.7244Z" />
    </svg>
  );
};

export default SvgComponent;
